export default "data:video/mp2t;base64,LyogZXNsaW50LWRpc2FibGUgcHJldHRpZXIvcHJldHRpZXIgKi8KZGVjbGFyZSBtb2R1bGUgJ0BjYXNoZnJlZXBheW1lbnRzL2Nhc2hmcmVlLWpzJzs="